export default {
    containerWidth: "1180px",
    mediaNumber: 4
}